import React from 'react';
import PropTypes from 'prop-types';
import { ConnectionOption, LogoOption, ColorOption } from '../EditorOption/';

const getOptionsValue = (options, value) =>
  options.find(opt => opt[0] === value)[1];

const EditoriOS = ({ onOptionChange, options, logos, defaultColor }) =>
  <ol className="code-container">
    <li className="line-row">
      <span>{'Lock'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.classic(clientId: "cid", domain: "domain")'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.allowedConnections('}</span>
      <ConnectionOption
        value={getOptionsValue(options, 'allowedConnections')}
        onChange={onOptionChange}
      />
      <span>{')'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.withStyle {'}</span>
    </li>
    <li className="line-row indent-2">
      <span>{'$0.logo = LazyImage(name:'}</span>
      <LogoOption
        value={getOptionsValue(options, 'logo')}
        onChange={onOptionChange}
        logos={logos}
      />
      <span>{')'}</span>
    </li>
    <li className="line-row indent-2">
      <span>{'$0.primaryColor = UIColor('}</span>
      <ColorOption
        value={getOptionsValue(options, 'primaryColor')}
        onChange={onOptionChange}
        defaultColor={defaultColor}
      />
      <span>{')'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'}'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.present(from: viewController)'}</span>
    </li>
  </ol>;

EditoriOS.propTypes = {
  onOptionChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  logos: PropTypes.array,
  defaultColor: PropTypes.string
};

export default EditoriOS;



// WEBPACK FOOTER //
// ./src/components/Editor/EditoriOS.js


// WEBPACK FOOTER //
// webpack:///src/components/Editor/EditoriOS.js